import {StandingsGroupCategoryDomainModel} from "./standings.group-category.domain-model";
import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";

export class StandingsGroupCategoryViewModel extends BaseViewModel {
  domainModel: StandingsGroupCategoryDomainModel;

  get num(): Number {
    return this.domainModel.num;
  }
}